import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Mixpanel from './mixpanel';

/**
 * PageTracker component that automatically tracks page views
 * This is used in the App.js file to track navigation between pages
 */
const PageTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Get page title based on the current route
    const getPageTitle = () => {
      // Extract the main path segment (e.g., /dashboard/settings -> dashboard)
      const mainPath = location.pathname.split('/')[1] || 'home';
      
      // Map paths to readable titles
      const pageTitles = {
        '': 'Home',
        'home': 'Home',
        'dashboard': 'Dashboard',
        'focus': 'Focus Tools',
        'journal': 'Journal',
        'process': 'Process',
        'plan': 'Planning Tools',
        'profile': 'User Profile',
        'admin': 'Admin Dashboard',
        'mental-imagery': 'Mental Imagery',
        'new-profile': 'Create Profile',
        'login': 'Login',
        'register': 'Register',
        'mental-performance-assessment': 'Mental Performance Assessment'
      };
      
      return pageTitles[mainPath] || mainPath.charAt(0).toUpperCase() + mainPath.slice(1);
    };
    
    // Track page view with enhanced information
    Mixpanel.trackPageView(
      location.pathname,
      getPageTitle()
    );
  }, [location]);
  
  return null;
};

export default PageTracker;
